<template>
	<div id="com-mod-returns-section" class="com-mod-section-container">
		<h3 class="com-mod-section-header">Returns</h3>
		<div class="row">
			<div class="col-md-12">
				<gross-net-index-returns-wrapper />
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<article
					v-if="isAuthorizedModule['returnsVolatility']"
					id="_returnsVolatility"
					class="gray-bar-top"
				>
					<volatility-return />
				</article>
				<article v-if="isAuthorizedModule['returnsGrowth10K']" id="_returnsGrowth10K">
					<growth-10k />
				</article>
			</div>
			<div class="col-md-6">
				<article>
					<div>
						<Yield />
					</div>
				</article>
				<article v-if="isAuthorizedModule['valuation']" id="_valuation">
					<Valuation />
				</article>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<portfolio-management
					:fund-objective="fundObjective"
					:breakpoint="getBreakpoint"
					:portfolio-data="getPortfolioManagers"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Growth10k from '_components_/Modules/Growth10kWrapper';
import GrossNetIndexReturnsWrapper from '_components_/Modules/GrossNetIndexReturnsWrapper';
import PortfolioManagement from '_components_/Modules/PortfolioManagement';
import Valuation from '_components_/Modules/Valuation';
import Yield from '_components_/Modules/Yield';
import VolatilityReturn from '_components_/Modules/VolatilityReturnWrapper';
import { mapGetters } from 'vuex';
export default {
	name: 'Returns',
	components: {
		'gross-net-index-returns-wrapper': GrossNetIndexReturnsWrapper,
		'portfolio-management': PortfolioManagement,
		Growth10k,
		Valuation,
		Yield,
		VolatilityReturn
	},
	computed: {
		...mapGetters(['getPortfolioManagers', 'getBreakpoint', 'getFundAttributes']),
		fundObjective() {
			return this.getFundAttributes && this.getFundAttributes.Objective || '';
		}
	}
};
</script>
